var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("This is Test Page!!")]),_c('button',{on:{"click":_vm.post}},[_vm._v("Click Here!!")]),_c('div',{attrs:{"id":"response"}},[_vm._v(_vm._s(_vm.response))])])
}
var staticRenderFns = []

export { render, staticRenderFns }